import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import Clickable from 'components/Common/Clickable'

// The border is drawn here rather than through Sheet's `border` prop so surfaces can
// flatten the card into a full-bleed band by zeroing the width.
export const StopSheet = styled(Sheet)`
  width: 100%;
  border: var(--trip-plan-canvas-section-border-width, 1px) solid ${props => props.theme.palette.neutral.surface.lightForeground};
  border-radius: var(--trip-plan-canvas-section-radius, ${props => props.theme.borderRadius.L});
  background: ${props => props.theme.palette.neutral.surface.normalBackground};
`

export const StopSheetContent = styled(Group)`
  padding: var(--itinerary-section-padding, ${rem(16)});
`

// Wraps the itinerary block. Nested inside the stop sheet, so surfaces that
// want a single inset (the mobile timeline) collapse this padding to zero.
export const StopItinerarySheet = styled(Sheet)`
  padding: var(--trip-plan-canvas-nested-padding, 0);
`

export const ImageContainer = styled(Clickable)`
  width: var(--itinerary-stop-image-size, ${rem(72)});
  height: var(--itinerary-stop-image-size, ${rem(72)});
  border-radius: ${props => props.theme.borderRadius.M};
  overflow: hidden;
  flex-shrink: 0;
`

export const PlaceholderImageContainer = styled(ImageContainer)`
  background: ${props => props.theme.palette.neutral.surface.lightBackgroundAlt};
`

export const StopMainContent = styled(Group)`
  min-width: 0;
`

export const StopDetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(20)};
  padding-top: ${rem(16)};
`

export const StopTitleContent = styled(Group)`
  min-width: 0;
`

export const ClickableHeading = styled(Clickable)`
  &:hover {
    text-decoration: underline;
  }
`

export const CreateItineraryPanel = styled(Group)`
  padding: ${rem(16)} ${rem(20)};
  background: ${props => props.theme.palette.neutral.surface.lightBackground};
  border-radius: ${props => props.theme.borderRadius.L};
`
